import {Component, Input, OnInit} from '@angular/core';
import {Broadcast} from "../../../model/broadcast/broadcast";
import {ControlAction} from "../../../model/broadcast/control";
import {Player} from "../../../model/broadcast/player";
import {UtilService} from "../../../services/util.service";
import {BatterComponent} from "../batter/batter.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-lower-third',
  templateUrl: './lower-third.component.html',
  styleUrls: ['./lower-third.component.scss'],
  imports: [
    BatterComponent,
    NgIf
  ],
  standalone: true
})
export class LowerThirdComponent implements OnInit {

  @Input() broadcast: Broadcast;
  @Input() controlAction: ControlAction;

  constructor(
    public utilservice: UtilService,
  ) { }

  ngOnInit(): void {
  }

  getNumber(): string {
    return this.utilservice.getNumber(this.broadcast?.lowerThird, this.broadcast)
  }

  getName(): string {
    return this.utilservice.getName(this.broadcast?.lowerThird, this.broadcast)
  }

  getTeamBgr(): string {
    return this.utilservice.getTeamBgr(this.broadcast?.lowerThird, this.broadcast)
  }

  getBgrWithOverlay(): string {
    return this.utilservice.getBgrWithOverlay(this.broadcast?.lowerThird, this.broadcast)

  }
}
